var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMake = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "23.000000pt",
  height: "16.000000pt",
  viewBox: "0 0 23.000000 16.000000",
  preserveAspectRatio: "xMidYMid meet"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,16.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M111 95 c-14 -81 -14 -82 8 -88 15 -4 20 5 30 58 14 81 14 82 -8 88 -15 4 -20 -5 -30 -58z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 91 c-28 -57 -28 -81 -3 -81 7 0 27 29 44 64 27 54 30 65 17 70 -27 10 -30 7 -58 -53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180 80 c0 -63 2 -70 20 -70 18 0 20 7 20 70 0 63 -2 70 -20 70 -18 0 -20 -7 -20 -70z"
}))));
export { SvgMake as ReactComponent };
export default __webpack_public_path__ + "00d404f157eb743a33ba96ba4c2b3a57.svg";